'use client';
import { Provider } from 'react-redux';
import { store } from './store';
import { AppStore } from '@/types/redux';

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <Provider store={store as AppStore}>{children}</Provider>;
}
